import { Table } from 'foundations-components/transitional/components/Table';
import { useTheme } from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import UserAvatarLink from '../common/UserAvatarLink';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PlaylistLink from './PlaylistLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PAGE_SIZE = 10;
const getPlaylistTypeLabel = playlistType => playlistType === 'LEARNING_PATH' ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.myTeam.playlists.hubspotPlaylist"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.myTeam.playlists.playlist"
});
const mockData = [{
  playlistId: 1,
  playlistType: 'STANDARD',
  userId: 101,
  userName: 'Helena Egan',
  userEmail: 'helena@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 10,
    completedItems: 5,
    playlistDurationInMinutes: 120,
    remainingDurationInMinutes: 60
  },
  assignedDate: Date.UTC(2024, 3, 1),
  dueDate: Date.UTC(2024, 3, 15),
  completedDate: null
}, {
  playlistId: 2,
  playlistType: 'STANDARD',
  userId: 102,
  userName: 'Mark Scout',
  userEmail: 'mark@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 8,
    completedItems: 8,
    playlistDurationInMinutes: 90,
    remainingDurationInMinutes: 0
  },
  assignedDate: Date.UTC(2024, 11, 1),
  dueDate: Date.UTC(2025, 0, 15),
  completedDate: Date.UTC(2025, 6, 15)
}, {
  playlistId: 3,
  playlistType: 'STANDARD',
  userId: 103,
  userName: 'Harmony Cobel',
  userEmail: 'harmony@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 10,
    completedItems: 4,
    playlistDurationInMinutes: 140,
    remainingDurationInMinutes: 84
  },
  assignedDate: Date.UTC(2024, 4, 1),
  dueDate: Date.UTC(2024, 4, 5),
  completedDate: null
}, {
  playlistId: 4,
  playlistType: 'LEARNING_PATH',
  userId: 104,
  userName: 'Seth Milchick',
  userEmail: 'seth@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 10,
    completedItems: 1,
    playlistDurationInMinutes: 150,
    remainingDurationInMinutes: 135
  },
  assignedDate: Date.UTC(2024, 8, 1),
  dueDate: Date.UTC(2024, 8, 12),
  completedDate: null
}, {
  playlistId: 5,
  playlistType: 'LEARNING_PATH',
  userId: 105,
  userName: 'Helena Egan',
  userEmail: 'helena@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 6,
    completedItems: 6,
    playlistDurationInMinutes: 70,
    remainingDurationInMinutes: 0
  },
  assignedDate: Date.UTC(2024, 3, 1),
  dueDate: Date.UTC(2024, 3, 15),
  completedDate: Date.UTC(2025, 5, 25)
}, {
  playlistId: 6,
  playlistType: 'LEARNING_PATH',
  userId: 106,
  userName: 'Helena Egan',
  userEmail: 'helena@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 7,
    completedItems: 0,
    playlistDurationInMinutes: 80,
    remainingDurationInMinutes: 80
  },
  assignedDate: Date.UTC(2025, 0, 1),
  dueDate: Date.UTC(2026, 0, 15),
  completedDate: null
}, {
  playlistId: 7,
  playlistType: 'LEARNING_PATH',
  userId: 107,
  userName: 'Irving Bailiff',
  userEmail: 'irving@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 20,
    completedItems: 3,
    playlistDurationInMinutes: 200,
    remainingDurationInMinutes: 170
  },
  assignedDate: Date.UTC(2024, 4, 1),
  dueDate: Date.UTC(2024, 4, 5),
  completedDate: null
}, {
  playlistId: 8,
  playlistType: 'LEARNING_PATH',
  userId: 108,
  userName: 'Dylan George',
  userEmail: 'dylan@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 20,
    completedItems: 3,
    playlistDurationInMinutes: 200,
    remainingDurationInMinutes: 170
  },
  assignedDate: Date.UTC(2024, 8, 1),
  dueDate: Date.UTC(2024, 8, 12),
  completedDate: null
}, {
  playlistId: 9,
  playlistType: 'LEARNING_PATH',
  userId: 109,
  userName: 'Ricken Hale',
  userEmail: 'ricken@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 12,
    completedItems: 12,
    playlistDurationInMinutes: 150,
    remainingDurationInMinutes: 0
  },
  assignedDate: Date.UTC(2024, 3, 1),
  dueDate: Date.UTC(2024, 3, 15),
  completedDate: Date.UTC(2025, 3, 5)
}, {
  playlistId: 10,
  playlistType: 'LEARNING_PATH',
  userId: 110,
  userName: 'Ricken Hale',
  userEmail: 'ricken@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 12,
    completedItems: 12,
    playlistDurationInMinutes: 150,
    remainingDurationInMinutes: 0
  },
  assignedDate: Date.UTC(2024, 4, 1),
  dueDate: Date.UTC(2024, 4, 5),
  completedDate: Date.UTC(2025, 3, 5)
}, {
  playlistId: 11,
  playlistType: 'STANDARD',
  userId: 111,
  userName: 'Harmony Cobel',
  userEmail: 'harmony@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 10,
    completedItems: 7,
    playlistDurationInMinutes: 120,
    remainingDurationInMinutes: 36
  },
  assignedDate: Date.UTC(2024, 5, 1),
  dueDate: null,
  completedDate: null
}, {
  playlistId: 12,
  playlistType: 'STANDARD',
  userId: 112,
  userName: 'Mark Scout',
  userEmail: 'mark@hubspot.com',
  playlistName: 'Digital Marketing Strategy - New Learner',
  playlistProgress: {
    totalPlaylistItems: 5,
    completedItems: 5,
    playlistDurationInMinutes: 60,
    remainingDurationInMinutes: 0
  },
  assignedDate: Date.UTC(2025, 3, 1),
  dueDate: Date.UTC(2025, 3, 21),
  completedDate: Date.UTC(2025, 3, 30)
}];
const getProgressPercent = ({
  completedItems,
  totalPlaylistItems
}) => Math.round(completedItems / Math.max(1, totalPlaylistItems) * 100);
const AllPlaylistsTable = () => {
  const theme = useTheme();
  const {
    isDesktop
  } = useMediaQuery();
  const playlistAssignments = mockData.slice(0, PAGE_SIZE);
  return /*#__PURE__*/_jsxs(Table, {
    "data-test-id": "all-playlists-table",
    hover: true,
    responsive: true,
    children: [/*#__PURE__*/_jsxs("colgroup", {
      children: [/*#__PURE__*/_jsx("col", {
        style: {
          width: '35%',
          borderInlineEnd: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '20%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '15%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '15%'
        }
      }), /*#__PURE__*/_jsx("col", {
        style: {
          width: '15%'
        }
      })]
    }), /*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tableColumns.playlist"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tableColumns.name"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tableColumns.progress"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tableColumns.dueDate"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.playlists.tableColumns.completed"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: playlistAssignments.map((playlistAssignment, index) => {
        const progressPercent = getProgressPercent(playlistAssignment.playlistProgress);
        return /*#__PURE__*/_jsxs("tr", {
          "data-test-id": "all-playlists-table-data-row",
          children: [/*#__PURE__*/_jsxs("td", {
            children: [/*#__PURE__*/_jsx(PlaylistLink, {
              playlistId: playlistAssignment.playlistId,
              playlistName: playlistAssignment.playlistName,
              position: index + 1
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
              children: getPlaylistTypeLabel(playlistAssignment.playlistType)
            })]
          }), /*#__PURE__*/_jsx("td", {
            children: /*#__PURE__*/_jsx(UserAvatarLink, {
              displayAvatar: isDesktop,
              position: index + 1,
              userEmail: playlistAssignment.userEmail,
              userId: playlistAssignment.userId,
              userName: playlistAssignment.userName
            })
          }), /*#__PURE__*/_jsx("td", {
            children: `${progressPercent}%`
          }), /*#__PURE__*/_jsx("td", {
            children: playlistAssignment.dueDate ? /*#__PURE__*/_jsx(FormattedDateTime, {
              format: "ll",
              type: "utc",
              value: playlistAssignment.dueDate
            }) : '--'
          }), /*#__PURE__*/_jsx("td", {
            children: playlistAssignment.completedDate ? /*#__PURE__*/_jsx(FormattedDateTime, {
              format: "ll",
              type: "utc",
              value: playlistAssignment.completedDate
            }) : '--'
          })]
        }, `${playlistAssignment.playlistId}-${playlistAssignment.userId}`);
      })
    })]
  });
};
export default AllPlaylistsTable;